import {IStore} from "modules/types/store";

export const getCountries = ({countries}: IStore) => countries;
